import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const addressesManagementReducer = foxGridReducer(
  gridNames.addressesManagement,
);

export default addressesManagementReducer;
